export const validateEmail = (value: string): boolean => {
  const regExp = /\S+@\S+\.\S+/
  return regExp.test(value || '')
}

export const validatePhone = (value: string): boolean => {
  if (!value) return false
  return value.length >= 10 && /^[0-9\s+-]*$/.test(value)
}
